// Testimonials data - Reviews from Google
export const testimonials = [
  {
    name: "Emma Currier",
    rating: 5,
    timeAgo: "4 weeks ago",
    text: "We had the Bar Spot host our Christmas party and they were great! Really efficient from getting set up to serving us all. Highly recommended!"
  },
  {
    name: "Maxine Bahra",
    rating: 5,
    timeAgo: "12 weeks ago",
    text: "We had an excellent service from Bar Spot. We hired a marquee and bar staff for my daughter's 21st. They were punctual and very friendly. I would definitely use them again and I highly recommend them."
  },
  {
    name: "Kealie Ahmad",
    rating: 5,
    timeAgo: "12 weeks ago",
    text: "We used Bar Spot for my daughter's 21st birthday party at home. The service beforehand was well organised, glasses and everything provided was excellent."
  },
  {
    name: "Thomas Plant",
    rating: 5,
    timeAgo: "27 weeks ago",
    text: "Late review but wanted to ensure it was finally done. BarSpot covered our wedding on 10th August 2024. Absolutely fantastic service from start to finish!"
  },
  {
    name: "Lucy Poole",
    rating: 5,
    timeAgo: "46 weeks ago",
    text: "We have used this company several times at our Venue Alcott Weddings and Events. It not only looks fab, but its really well run and its a great service. We look forward to seeing them again this season!"
  },
  {
    name: "Nicola Hilton",
    rating: 5,
    timeAgo: "19 Dec 2024",
    text: "Fantastic service. A great range of bespoke cocktails and nothing was too much trouble. Highly recommended"
  },
  {
    name: "Nyakeh Joe Alpha",
    rating: 5,
    timeAgo: "1 Sept 2024",
    text: "We had the pleasure of having Barspot as our bartenders for our August wedding, and they truly exceeded all expectations. Outstanding service!"
  },
  {
    name: "Daniel Sawyer",
    rating: 5,
    timeAgo: "15 Aug 2024",
    text: "I hired Bar Spot for a works party. Sam and his team went above and beyond. They made everyone feel welcome, very professional service."
  },
  {
    name: "Helen Howarth",
    rating: 5,
    timeAgo: "2 Jul 2024",
    text: "We would highly recommend Bar Spot, they provided a bar service for our wedding and they were excellent from start to finish."
  },
  {
    name: "Georgie Rowe",
    rating: 5,
    timeAgo: "1 Jul 2024",
    text: "Bar Spot were a supplier for our work event at Alcott Farm. The team were incredible in setting up, understanding our needs perfectly."
  },
  {
    name: "Catriona Foulkes",
    rating: 5,
    timeAgo: "1 Sept 2023",
    text: "The bar was amazing! Lovely cocktails, service with a smile, and all served from their incredibly cool and beautifully decorated caravan!!"
  },
  {
    name: "Faye Johnson",
    rating: 5,
    timeAgo: "26 Aug 2023",
    text: "Sam and co came to a house we had rented for my mums 60th, spent the evening with us & we loved having the bar there. Lovely people & great bar! The AU went down a treat 😅 Thank you."
  },
  {
    name: "Rod Pickard",
    rating: 5,
    timeAgo: "25 Aug 2023",
    text: "Friendly couple, well priced and accommodating. Handled a large group of Geordies easily."
  },
  {
    name: "Emmanuel Afrifa",
    rating: 5,
    timeAgo: "30 Sept 2022",
    text: "Very professional, exceptional customer service, highly recommended them for events."
  },
  {
    name: "Heidi Matheron",
    rating: 5,
    timeAgo: "30 Sept 2022",
    text: "I was recommended Barspot by a work colleague and I am so glad I listened to them. Samuel, Clare and Louka really made our event special."
  },
  {
    name: "jay 12",
    rating: 5,
    timeAgo: "30 Sept 2022",
    text: "Great company to work with! I highly recommend Bar Spot Ltd. Used these guys recently for an event and they were super professional, efficient and added great value to my event"
  },
  {
    name: "Nick West",
    rating: 5,
    timeAgo: "30 Sept 2022",
    text: "I would give 6 stars if possible. From start to finish Sam was amazing. Phone calls to discuss what we were planning and everything was perfect."
  },
  {
    name: "Cameron Muir",
    rating: 5,
    timeAgo: "23 Jul 2022",
    text: "I must say, what a brilliant little bar!! Sam was awesome! Nicest bar staff at a wedding I've been to"
  }
];
